// src/services/adminParametres.js
//
// Domaine Admin — Paramètres plateforme / maintenance

import { apiFetch } from './adminHttp';

export async function getParametres() {
  return apiFetch('/admin/parametres', {
    method: 'GET',
  });
}

/**
 * POST /admin/parametres/maintenance
 * Body : { active: boolean, message?: string } — message max 500 caractères (contrat).
 * Permission PARAMETRES_MODIFIER.
 * Note contrat : maintenance.active est stocké mais ne bloque pas automatiquement les routes Admin.
 */
export async function toggleMaintenance(enabled, message) {
  const body = { active: Boolean(enabled) };
  if (message !== undefined && message !== null && message !== '') {
    const msg = String(message);
    if (msg.length > 500) {
      const err = new Error('Le message de maintenance ne peut pas dépasser 500 caractères.');
      err.status = 400;
      throw err;
    }
    body.message = msg;
  }
  return apiFetch('/admin/parametres/maintenance', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
